/* Budovo storefront enhancements */
(function () {
  'use strict';

  /* ---------- Recently viewed products ---------- */
  var KEY = 'budovo_recently_viewed';
  var MAX_STORE = 12;
  var MAX_SHOW = 8;

  function readList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function writeList(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
  }

  // Current product handle from the URL (works on /products/<handle>, ignores variant/query/locale suffix)
  var match = location.pathname.match(/\/products\/([^\/?#]+)/);
  var currentHandle = match ? decodeURIComponent(match[1]) : null;

  // Track: push current product to the front of the list
  if (currentHandle) {
    var list = readList().filter(function (h) { return h !== currentHandle; });
    list.unshift(currentHandle);
    writeList(list.slice(0, MAX_STORE));
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_' + w + 'x$1$2');
  }

  function renderRecentlyViewed() {
    var container = document.getElementById('budovo-recently-viewed');
    if (!container) return;
    var grid = container.querySelector('[data-brv-grid]');
    if (!grid) return;

    var handles = readList().filter(function (h) { return h !== currentHandle; }).slice(0, MAX_SHOW);
    if (!handles.length) return;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = '';
      products.forEach(function (p) {
        if (!p || !p.available) return; // skip sold-out / missing
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var imgTag = img
          ? '<div class="brv-card__img"><img loading="lazy" src="' + sized(img, 400) + '" alt="' + esc(p.title) + '"></div>'
          : '<div class="brv-card__img brv-card__img--empty"></div>';
        html += '<a class="brv-card" href="/products/' + encodeURIComponent(p.handle) + '">' +
          imgTag +
          '<div class="brv-card__info">' +
          (p.vendor ? '<span class="brv-card__vendor">' + esc(p.vendor) + '</span>' : '') +
          '<span class="brv-card__title">' + esc(p.title) + '</span>' +
          '<span class="brv-card__price">' + money(p.price) + '</span>' +
          '</div></a>';
      });
      if (html) {
        grid.innerHTML = html;
        container.hidden = false;
      }
    });
  }

  /* ---------- Sticky bar free-shipping progress ---------- */
  var FREE_SHIP_THRESHOLD = 20000; // cents ($200 Standard free shipping)

  function updateStickyFreeship(cart) {
    var els = document.querySelectorAll('[data-budovo-freeship]');
    if (!els.length) return;
    var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    els.forEach(function (el) {
      var threshold = parseInt(el.getAttribute('data-fs-threshold'), 10) || FREE_SHIP_THRESHOLD;
      var remaining = threshold - total;
      var pct = remaining > 0 ? Math.min(100, Math.round((total * 100) / threshold)) : 100;
      var fill = el.querySelector('[data-budovo-freeship-fill]');
      var msg = el.querySelector('[data-budovo-freeship-msg]');
      if (fill) fill.style.width = pct + '%';
      if (msg) {
        msg.innerHTML = remaining > 0
          ? money(remaining) + ' away from <strong>FREE shipping</strong>'
          : '<strong>You’ve unlocked FREE shipping!</strong>';
      }
    });
  }

  function refreshStickyFreeship() {
    if (!document.querySelector('[data-budovo-freeship]')) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) updateStickyFreeship(c); })
      .catch(function () {});
  }

  // Refresh after any add-to-cart (sticky button or main button both use .add-to-cart-button)
  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest && t.closest('.add-to-cart-button, button[name="add"]');
    if (btn) {
      setTimeout(refreshStickyFreeship, 700);
      // Quick press-pulse feedback on the button
      btn.classList.remove('budovo-add-pulse');
      void btn.offsetWidth; // reflow so the animation restarts on rapid clicks
      btn.classList.add('budovo-add-pulse');
    }
  }, true);

  /* ---------- Scroll reveal for below-the-fold sections ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var scope = document.querySelector('main') || document.body;
    var sections = scope.querySelectorAll('.shopify-section');
    if (!sections.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-revealed');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.01, rootMargin: '0px 0px 14% 0px' });
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < sections.length; i++) {
      var el = sections[i];
      // Leave anything already at/above the fold visible (no flash, protects LCP)
      if (el.getBoundingClientRect().top < vh) continue;
      el.classList.add('budovo-reveal');
      io.observe(el);
    }
  }

  /* ---------- Scroll container ----------
     Horizon scrolls .page-wrapper (height:100dvh; overflow-y:auto) at >=990px and
     locks html/body to overflow:hidden; below 990px the window scrolls normally.
     So window.scrollTo/pageYOffset/scroll events are all no-ops on desktop. */
  function scrollBox() {
    var pw = document.querySelector('.page-wrapper');
    if (pw && /(auto|scroll)/.test(getComputedStyle(pw).overflowY) && pw.scrollHeight > pw.clientHeight + 1) {
      return pw;
    }
    return null; // window scrolls
  }

  function scrollOffset() {
    var box = scrollBox();
    return box ? box.scrollTop : (window.pageYOffset || document.documentElement.scrollTop || 0);
  }

  function scrollToTop(smooth) {
    var box = scrollBox();
    var opts = { top: 0, behavior: smooth ? 'smooth' : 'auto' };
    if (box) box.scrollTo(opts);
    else window.scrollTo(opts);
  }

  function onScrollAny(fn) {
    // scroll events don't bubble, so listen on both possible scrollers
    window.addEventListener('scroll', fn, { passive: true });
    var pw = document.querySelector('.page-wrapper');
    if (pw) pw.addEventListener('scroll', fn, { passive: true });
  }

  /* ---------- Back-to-top button ---------- */
  function initBackToTop() {
    if (document.querySelector('.budovo-to-top')) return;
    var btn = document.createElement('button');
    btn.className = 'budovo-to-top';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5"/><path d="M6 11l6-6 6 6"/></svg>';
    document.body.appendChild(btn);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    btn.addEventListener('click', function () {
      scrollToTop(!reduce);
    });
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        if (scrollOffset() > 600) btn.classList.add('is-visible');
        else btn.classList.remove('is-visible');
        ticking = false;
      });
    }
    onScrollAny(onScroll);
    onScroll();
  }

  /* ---------- Cart bubble bounce on add ---------- */
  function initCartBounce() {
    var bubbles = document.querySelectorAll('.cart-bubble');
    if (!bubbles.length || !('MutationObserver' in window)) return;
    function countOf(b) {
      var el = b.querySelector('.cart-bubble__text-count');
      var n = el ? parseInt((el.textContent || '').replace(/\D/g, ''), 10) : 0;
      return isNaN(n) ? 0 : n;
    }
    Array.prototype.forEach.call(bubbles, function (b) {
      var last = countOf(b);
      var mo = new MutationObserver(function () {
        var now = countOf(b);
        if (now > last) {
          b.classList.remove('budovo-bounce');
          void b.offsetWidth;
          b.classList.add('budovo-bounce');
        }
        last = now;
      });
      mo.observe(b, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
      b.addEventListener('animationend', function () { b.classList.remove('budovo-bounce'); });
    });
  }

  /* ---------- Logo / "Home" click animation ---------- */
  var HOME_ANIM_MS = 360;

  function initHomeClick() {
    var logo = document.querySelector('.header-logo');
    var rootPath = '/';
    try {
      rootPath = new URL((logo && logo.getAttribute('href')) || '/', location.origin).pathname;
    } catch (e) {}
    rootPath = rootPath.replace(/\/+$/, '') || '/';

    function isHomeLink(a) {
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return false;
      if (a.target && a.target !== '' && a.target !== '_self') return false;
      if (a.hasAttribute('download')) return false;
      var url;
      try { url = new URL(href, location.href); } catch (e) { return false; }
      if (url.origin !== location.origin || url.search || url.hash) return false;
      return (url.pathname.replace(/\/+$/, '') || '/') === rootPath;
    }

    function pop(el) {
      if (!el) return;
      el.classList.remove('budovo-home-pop');
      void el.offsetWidth; // reflow so repeat clicks re-run the animation
      el.classList.add('budovo-home-pop');
    }

    function ripple(x, y) {
      var el = document.createElement('span');
      el.className = 'budovo-home-ripple';
      var vw = window.innerWidth || 0;
      var vh = window.innerHeight || 0;
      var reach = Math.max(
        Math.sqrt(x * x + y * y),
        Math.sqrt((vw - x) * (vw - x) + y * y),
        Math.sqrt(x * x + (vh - y) * (vh - y)),
        Math.sqrt((vw - x) * (vw - x) + (vh - y) * (vh - y))
      );
      el.style.setProperty('--bx', x + 'px');
      el.style.setProperty('--by', y + 'px');
      el.style.setProperty('--bs', Math.ceil(reach / 9) + '');
      document.body.appendChild(el);
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 700);
    }

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || !isHomeLink(a)) return;
      // Only the header logo and header nav links (incl. the mobile drawer)
      if (!a.classList.contains('header-logo') && !a.closest('#header-group')) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      e.preventDefault();

      pop(a);
      if (logo && logo !== a) pop(logo); // text "Home" link also winks the logo

      var rect = a.getBoundingClientRect();
      var x = e.clientX || rect.left + rect.width / 2;
      var y = e.clientY || rect.top + rect.height / 2;
      ripple(x, y);

      var onHome = (location.pathname.replace(/\/+$/, '') || '/') === rootPath && !location.search;
      if (!onHome) document.documentElement.classList.add('budovo-home-leaving');

      var href = a.href;
      if (onHome) {
        // Already home: ride the animation straight up to the top of the page
        scrollToTop(true);
      } else {
        setTimeout(function () {
          window.location.href = href;
        }, HOME_ANIM_MS);
      }
    });

    // Restore state if the visitor comes back via the bfcache
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      document.documentElement.classList.remove('budovo-home-leaving');
      var popped = document.querySelectorAll('.budovo-home-pop');
      for (var i = 0; i < popped.length; i++) popped[i].classList.remove('budovo-home-pop');
    });
  }

  function initBudovo() {
    renderRecentlyViewed();
    refreshStickyFreeship(); // correct the Liquid-rendered value against the live (uncached) cart
    initReveal();
    initBackToTop();
    initCartBounce();
    initHomeClick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBudovo);
  } else {
    initBudovo();
  }
})();
